import React from "react";
import CustomSpan from "../../components/CustomSpan";
import Table from "../../components/table/Table";
import ExpandablePanel from "../../components/ExpandablePanel";
import { formatDateTime } from "../../utils/datetime-utils";
import {
  getJudgmentResultBackground,
  getJudgmentResultSymbol,
  getJudgmentResultColor,
} from "../../utils/display-utils";
import { useSelector } from "react-redux";

function JudgmentContent({ judgments }) {
  const resultSymbolSetting = useSelector(
    (s) => s.app_settings.inspection_display.inspection_result_symbol
  );

  return (
    <ExpandablePanel title="判定結果">
      {Array.isArray(judgments) && judgments.length > 0 ? (
        <div className="relative rounded-lg border border-[#e0e0e0] w-full">
          <Table className="no-drop-shadow-table" striped>
            <Table.Head className="border-b border-tenken-gray-200">
              <Table.HeadCell className="!normal-case w-[76px] !bg-white whitespace-nowrap">
                <span>No.</span>
              </Table.HeadCell>
              <Table.HeadCell className="w-[320px] !bg-white whitespace-nowrap">
                <span>承認者</span>
              </Table.HeadCell>
              <Table.HeadCell className="w-[160px] !bg-white whitespace-nowrap">
                <span>判定日</span>
              </Table.HeadCell>
              <Table.HeadCell className="w-[140px] !bg-white whitespace-nowrap">
                <span>判定結果</span>
              </Table.HeadCell>
              <Table.HeadCell className="!bg-white whitespace-nowrap">
                <span>判定コメント</span>
              </Table.HeadCell>
            </Table.Head>
            <Table.Body className="devide-y text-base">
              {judgments.map((item, index) => (
                <Table.Row
                  key={index}
                  className="odd:bg-gray-50 even:bg-white odd:dark:bg-gray-70 even:dark:bg-gray-800 border-b border-tenken-gray-200"
                >
                  <Table.Cell>
                    <span>{index + 1}</span>
                  </Table.Cell>
                  <Table.Cell>
                    <CustomSpan
                      text={`${item.judgment_user.name} (${item.judgment_user.username})`}
                    />
                  </Table.Cell>
                  <Table.Cell>
                    <CustomSpan
                      text={formatDateTime(new Date(item.judgment_datetime))}
                    ></CustomSpan>
                  </Table.Cell>
                  <Table.Cell>
                    <span
                      style={{
                        color: getJudgmentResultColor(
                          item.result,
                          resultSymbolSetting
                        ),
                        background: getJudgmentResultBackground(
                          item.result,
                          resultSymbolSetting
                        ),
                      }}
                    >
                      {getJudgmentResultSymbol(
                        item.result,
                        resultSymbolSetting
                      )}
                    </span>
                    <span className="ml-1">
                      {Number(item.result) === 1 && "承認"}
                      {Number(item.result) === 0 && "差し戻し"}
                    </span>
                  </Table.Cell>
                  <Table.Cell>
                    <CustomSpan
                      className="whitespace-pre-wrap"
                      text={item.comment}
                    />
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
      ) : (
        <span className="flex justify-center items-center w-full text-tenken-gray-700 lg:text-[18px] text-base">
          判定履歴なし
        </span>
      )}
    </ExpandablePanel>
  );
}

export default JudgmentContent;
